'use strict';

function SearchController($rootScope, $scope, $log, objectMakerFactory) {
	var self = this;

	this.configureSearchBoxEvent = function() {
		google.maps.event.addListener($scope.searchViewControl.autocomplete, 'place_changed', function() {
			try {
				var place = $scope.searchViewControl.autocomplete.getPlace();
				(place.place_id) && $rootScope.$emit('didSelectPlace', new google.maps.LatLng(place.geometry.location.lat(), place.geometry.location.lng()));
				(!place.place_id) && self.processButtonSearch(place.name);
				self.aplicarZoomConsulta();
			} catch(err) {
				console.log(err);
			}
		});
	};

	this.processButtonSearch = function(location) {
		$scope.searchViewControl.autocompleteService.getPlacePredictions({
				input: location,
				componentRestrictions: {country: 'br'}
			}, function(predictions, status) {
				try {
					$rootScope.$emit('didSelectPredictionPlace', predictions[0]);
					document.getElementById('pac-input').value = predictions[0].description;
					(!$scope.$$phase) && $scope.$apply();
					if ('OK' === status) {
						setTimeout(function(){self.aplicarZoomConsulta(); }, 300);
					}
				} catch(err) {
					$log.error('status for location not OK - ' + err);
				}
			}
		);
	};

	this.initSearchController = function() {
		$scope.searchViewControl = objectMakerFactory.viewObjectControlForSearchBar();
		try {
			$scope.searchViewControl.autocomplete = new google.maps.places.Autocomplete(document.getElementById('pac-input'), {
				types: ['geocode'],
				componentRestrictions: {country: "br"}
			});
			$scope.searchViewControl.autocompleteService = new google.maps.places.AutocompleteService(null,{ types: ['geocode']});
			self.configureSearchBoxEvent();
		} catch(err) {
			console.log(err);
		}
	};

	$scope.$on('initSearchController', function() {
		self.initSearchController();
	});

	$scope.centerOnMe = function() {
		$rootScope.$emit('centerMapOnMe');
	};

	this.aplicarZoomConsulta = function() {
			$rootScope.$emit('zoomParaConsulta');
	};

	$scope.search = function() {
		if($scope.searchViewControl.location.fullAddress) {
			self.processButtonSearch($scope.searchViewControl.location.fullAddress);
		}
	};

	$scope.clearSearchBar = function() {
		document.getElementById('pac-input').blur();
		document.getElementById('pac-input').value = '';
		$scope.searchViewControl.location = {fullAddress: '', latitude: '', longitude: ''};
	};
}
SearchController.$inject = ['$rootScope', '$scope', '$log', 'objectMakerFactory']
export default SearchController


// WEBPACK FOOTER //
// ./src/app/scripts/controllers/searchController.js